<template>
    <div class="waterfallView-container">
        <div class="tag-arear flex-layout-h">
            <div
                :class="
                    index === currentIndex
                        ? 'tags-checked text-layout-center f-12'
                        : 'tags text-layout-center f-12'
                "
                v-for="(item, index) in fallTags"
                :key="index"
                @click="tagsClick(index)"
            >
                {{ item.type }}
            </div>
        </div>
        <div class="waterfall">
            <waterfall
                :grow="grow"
                :lineGap="'1'"
                :watch="items"
                ref="waterfall"
                class="flex-layout-v"
            >
                <waterfall-slot
                    v-for="(item, index) in items"
                    :width="item.width"
                    :height="item.height"
                    :order="index"
                    :key="index"
                    class="views flex-layout-v flex-item-center"
                    move-class="item-move"
                >
                    <div
                        class="views-item flex-layout-v flex-item-center"
                        :index="item.index"
                        @click="viewsClick(item)"
                        :style="{ height: 187 + 'px' }"
                    >
                        <div
                            class="item-img"
                            :style="{
                                backgroundImage: 'url(' + item.smallImage + ')',
                            }"
                        ></div>
                        <div class="item-title text-layout-center">{{ item.awardName }}</div>
                        <section v-if="item.awardStatus === 0">
                            <template v-if="!isOldCustomer">
                                <div class="item-desc text-layout-center">完成首借后可领取</div>
                            </template>
                            <template v-else>
                                <div class="item-desc text-layout-center">
                                    {{ item.requiredScore }}活力值专享
                                </div>
                            </template>
                        </section>
                        <section v-else-if="item.awardStatus === 10">
                            <div class="item-descBtn text-layout-center">免费领取</div>
                        </section>
                        <section v-else-if="item.awardStatus === 20">
                            <div class="item-descGray text-layout-center">已领取</div>
                        </section>
                    </div>
                </waterfall-slot>
            </waterfall>
            <div
                class="
                    waterfall-loading
                    text-layout-center
                    flex-layout-h flex-justify-center flex-item-center
                "
            >
                <!-- <van-loading size="24px" v-if="showLoading()">加载中...</van-loading>
                <span v-if="loadingFinish">{{ loadindTxt }}</span> -->
                <section v-if="loadingStatus !== 2">
                    <van-loading size="24px" v-if="loadingStatus === 0">加载中...</van-loading>
                    <span v-if="loadingStatus === 1">{{ loadindTxt }}</span>
                    <!-- <span v-if="loadingStatus === 3">上拉加载更多</span> -->
                </section>
            </div>
        </div>
        <Dialog
            :show="showDialog"
            title="完成首笔借款领最高价值1988元专享权益"
            lefttxt="再看看"
            righttxt="立即借款"
            @giveupBtn="giveupBtn"
            @continueBtn="continueBtn"
        />
    </div>
</template>

<script>
import Waterfall from 'vue-waterfall/lib/waterfall';
import WaterfallSlot from 'vue-waterfall/lib/waterfall-slot';
import homemixin from '@common/js/mixin';
import Dialog from './LoanDialog';

export default {
    components: {
        Waterfall,
        WaterfallSlot,
        Dialog
    },
    mixins: [homemixin],
    props: ['shouye', 'switch3DCat'],

    data() {
        return {
            loadindTxt: '',
            loadingFinish: false,
            loadingError: false,
            loadingStatus: 3, // 0 可加载 1加载结束 2加载异常 3接口请求完成
            showDialog: false,
            scrollText: '上拉加载更多',
            currentIndex: 0,
            pageNo: 1,
            pageSize: 10,
            fallTags: [],
            grow: [1, 1],
            items: [],
            isOldCustomer: false,
            currentScore: 0
        };
    },
    watch: {
        showDialog(n, o) {
            if (n) {
                this.POINT('h5_element_imp', {
                    tgt_event_id: 'h5_ACT_privilege_box',
                    tgt_name: 'h5-ACT-成长权益-弹窗',
                    page: 'super-成长权益页',
                    param: `${this.currentScore}`,
                    param1: '未激活弹窗'
                });
            }
        }
    },

    created() {
        if (!this.shouye) {
            this.pageSize = 10;
        }
        // this.parseLocalStroage();
        // console.log('xxxx', this.isOldCustomer, this.currentScore);
        this.getTagsList();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScrollListener);
    },
    mounted() {
        // this.parseLocalStroage();
        window.addEventListener('scroll', this.onScrollListener);
        this.loopDom = this.debounce2(
            () => {
                let parentNodes =
                    document.getElementsByClassName('vue-waterfall') &&
                    document.getElementsByClassName('vue-waterfall')[0].childNodes;
                for (let i = 0; i < parentNodes.length; i++) {
                    if (this.isElementInViewport(parentNodes[i])) {
                        this.trackerElem(this.items[i]);
                    }
                }
            },
            500,
            true
        );
        this.requestListApi = this.debounce2(
            () => {
                this.getbenefitlistApi();
            },
            500,
            true
        );

        this.openDetailPage = this.debounce2(
            item => {
                setTimeout(() => {
                    this.openLink(
                        `${window.location.protocol}//invgrowth.ppdai.com/#/interestsDetail/?key=${item.key}`
                    );
                }, 200);
            },
            200,
            true
        );
    },
    methods: {
        giveupBtn() {
            this.showDialog = false;
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_privilege_box',
                tgt_name: 'h5-ACT-成长权益-弹窗',
                page: 'super-成长权益页',
                param: `${this.currentScore}`,
                param1: '未激活弹窗',
                param2: '再看看'
            });
        },
        showLoading() {
            if (this.loadingError) {
                return false;
            } else {
                if (this.loadingFinish) {
                    return false;
                }
            }
            return true;
        },
        onScrollListener(e) {
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop + window.innerHeight + 150 >= document.body.clientHeight) {
                this.requestListApi();
            }
            this.loopDom();
        },

        continueBtn() {
            this.showDialog = false;
            this.openLink('ppdloanapp://account/validatorOrEvaluate');
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_privilege_box',
                tgt_name: 'h5-ACT-成长权益-弹窗',
                page: 'super-成长权益页',
                param: `${this.currentScore}`,
                param1: '未激活弹窗',
                param2: '立即借款'
            });
        },
        getTagsList4Refresh() {
            this.pageNo = 1;
            this.loadindTxt = '';
            this.loadingFinish = false;
            this.loadingError = false;
            this.showDialog = false;
            console.log('getTagsList4Refresh', this.pageNo);
            this.getTagsList();
        },
        async getTagsList() {
            const { Result, Content } = await this.$http.getbenefitsummary({});
            if (Result === 200) {
                this.isOldCustomer = Content.isOldCustomer;
                this.currentScore = Content.totalScore;
                this.fallTags = [{ type: '全部' }, ...Content.typeInfoList];
                this.getbenefitlistApi(true);
            }
        },
        async getbenefitlistApi(switchTab = false) {
            let type = this.fallTags[this.currentIndex].type;
            try {
                this.loadingStatus = 0;
                const { Result, Content, ResultMessage } = await this.$http.getbenefitlist({
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                    type: type === '全部' ? '' : type
                });
                this.loadingError = false;

                if (Result === 200) {
                    if (switchTab) {
                        this.items = [];
                    }
                    this.appendListData(
                        Content.benefitInfoList.filter(item => {
                            if (switchTab) {
                                return true;
                            } else {
                                let finded = this.items.find(value => {
                                    return value.key === item.key;
                                });
                                return !finded;
                            }
                        })
                    );
                    this.loadingFinish = false;

                    if (Content.benefitInfoList && Content.benefitInfoList.length !== 0) {
                        this.pageNo++;
                    }
                    if (Content.benefitInfoList && Content.benefitInfoList.length < this.pageSize) {
                        this.loadingFinish = true;
                        this.loadingStatus = 1;
                        this.loadindTxt = '- 没有更多了 -';
                    } else {
                        this.loadingStatus = 3;
                    }
                } else {
                    this.loadingStatus = 2;
                    this.loadingError = true;
                    this.$toast(ResultMessage);
                    this.POINT('h5_auth', {
                        auth_tgt: 'super_privilege_errorMsg',
                        auth_tgt_name: 'super-成长权益-报错集合',
                        page: 'super-普惠权益列表',
                        ret_code: Result,
                        param: ResultMessage,
                        param1: '/growth/duiba/getbenefitlist'
                    });
                }
            } catch (error) {
                this.loadingStatus = 2;
                this.loadingError = true;
                this.$toast(error);
            } finally {
            }
        },
        trackerElem(item) {
            this.POINT('h5_element_imp', {
                tgt_event_id: this.shouye ? 'h5_ACT_privilege_inclusive' : 'h5_ACT_grade_inclusive',
                tgt_name: this.shouye ? 'h5-ACT-成长权益-普惠权益' : 'h5-ACT-等级权益-普惠权益',
                page: this.shouye ? 'super-成长权益页' : 'super-等级权益-普惠权益',
                param: this.isOldCustomer ? `${this.currentScore}` : -1,
                param1: item.awardName,
                param2: item.key,
                param3: item.type,
                param4:
                    item.awardStatus === 10
                        ? '免费领取'
                        : item.awardStatus === 0
                            ? this.isOldCustomer
                                ? `${item.requiredScore}活力值专享`
                                : '完成首借后可领取'
                            : item.awardStatus === 20
                                ? '已领取'
                                : '',
                param5: this.switch3DCat ? '是' : '否'
            });
        },
        appendListData(list) {
            if (list.length <= 0) {
                this.scrollText = '- 没有更多了 -';
                return;
            }
            this.items = [
                ...this.items,
                ...list.map((item, index) => {
                    return {
                        ...item,
                        ...{ index: this.items.length, height: '160', width: '165' }
                    };
                })
            ];

            this.items[0].height = '160';
            this.items.map((item, index) => {
                // if (item.awardName.length >= 12) {
                //     item.height = `${parseInt(item.height, 10) + 10}`;
                // }
                return item;
            });
            this.scrollText = '上拉加载更多';
        },
        tagsClick(value) {
            this.currentIndex = value;
            this.pageNo = 1;
            this.POINT('h5_clk', {
                tgt_event_id: this.shouye
                    ? 'h5_ACT_privilege_inclusiveScreen'
                    : 'h5_ACT_grade_inclusiveScreen',
                tgt_name: 'h5-ACT-成长权益-普惠权益筛选栏',

                page: this.shouye ? 'super-成长权益页' : 'super-等级权益-普惠权益',
                param: this.isOldCustomer ? `${this.currentScore}` : -1,
                param1: this.fallTags[this.currentIndex].type,
                param2: this.switch3DCat ? '是' : '否'
            });
            this.getbenefitlistApi(true);
        },
        viewsClick(item) {
            this.POINT('h5_clk', {
                tgt_event_id: this.shouye ? 'h5_ACT_privilege_inclusive' : 'h5_ACT_grade_inclusive',
                tgt_name: this.shouye ? 'h5-ACT-成长权益-普惠权益' : 'h5-ACT-等级权益-普惠权益',
                page: this.shouye ? 'super-成长权益页' : 'super-等级权益-普惠权益',
                param: this.isOldCustomer ? `${this.currentScore}` : -1,
                param1: item.awardName,
                param2: item.key,
                param3: item.type,
                param4:
                    item.awardStatus === 10
                        ? '免费领取'
                        : item.awardStatus === 0
                            ? this.isOldCustomer
                                ? `${item.requiredScore}活力值专享`
                                : '完成首借后可领取'
                            : item.awardStatus === 20
                                ? '已领取'
                                : ''
            });
            if (!this.isOldCustomer && item.awardStatus === 0) {
                this.showDialog = true;
                return;
            }
            this.openDetailPage(item);

            // this.$router.push({
            //     path: '/interestsDetail',
            //     query: {
            //         key: item.key
            //     }
            // });
        }
    }
};
</script>

<style lang="less" scoped>
@import '~@common/style/common.less';

.waterfallView-container {
    .tag-arear {
        justify-content: flex-start;
        padding-left: 18px;
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        height: 35px;
        > .tags {
            height: 28px;
            min-width: 70px;
            position: relative;
            background-color: #fff;
            color: #002a3c;
            line-height: 28px;
            margin-right: 10px;
            border-radius: 14px;
            padding: -1px 7px;
            border: solid 1px rgba(221, 221, 221, 1);
            // &::after {
            //     border-radius: 100px;
            //     content: '';
            //     position: absolute;
            //     top: -50%;
            //     bottom: -50%;
            //     left: -50%;
            //     right: -50%;
            //     width: 200%;
            //     height: 200%;
            //     -webkit-transform: scale(0.5);
            //     transform: scale(0.5);
            //     border: solid 1px rgba(221, 221, 221, 1);
            //     box-sizing: border-box;
            // }
        }
        > .tags-checked {
            height: 28px;
            min-width: 70px;
            padding: 9px 11px;
            background-color: rgba(255, 129, 67, 1);
            border-radius: 14px;
            color: white;
            margin-right: 10px;
        }
    }
    .tag-arear::-webkit-scrollbar {
        display: none;
    }
    .waterfall {
        padding: 0 18px;
        margin-top: 10px;
        &-loading {
            color: #c9c9c9;
            height: 40px;
            line-height: 42px;
            span {
                margin-left: 10px;
            }
        }
        .views {
            .views-item {
                width: 165px;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 2px 8px 0px rgba(186, 201, 207, 0.32);
                border-radius: 6px;
                margin-bottom: 10px;
                .item-img {
                    border-top-right-radius: 6px;
                    border-top-left-radius: 6px;
                    width: 165px;
                    height: 78px;
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center center;
                }
                .item-title {
                    width: 100%;
                    margin-top: 10px;
                    font-size: 14px;
                    height: 14px;
                    line-height: 16px;
                    font-weight: bold;
                    font-family: 'sans-serif' !important;
                    padding: 0 17px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #002a3c;
                    white-space: nowrap;
                }
                .item-desc {
                    margin-top: 10px;
                    width: 113px;
                    height: 24px;
                    border-radius: 13px;
                    color: #fdb18c;
                    .f-12-bold();
                    line-height: 22px;
                    border: 1px solid rgba(253, 177, 140, 1);
                }
                .item-descGray {
                    margin-top: 10px;
                    width: 74px;
                    height: 24px;
                    .f-12-bold();
                    color: white;
                    line-height: 26px;
                    background: rgba(255, 129, 67, 1);
                    border-radius: 13px;
                    opacity: 0.4;
                }
                .item-descBtn {
                    margin-top: 10px;
                    width: 74px;
                    height: 24px;
                    .f-12-bold();
                    color: white;
                    line-height: 26px;
                    background: rgba(255, 129, 67, 1);
                    border-radius: 13px;
                }
                &:first-child {
                    margin-top: 0px;
                }
            }
        }
    }
    .item-move {
        // transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
        // -webkit-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
    }
    .no-result {
        font-size: 13px;
        font-weight: normal;
        color: rgba(77, 81, 90, 1);
        margin-top: 20px;
    }
}
</style>
